import { gsap } from 'gsap';

export function addScrollAnimation(wrapper, options = {}) {
  if (wrapper) {
    const {
      offset = -150,
      range = 200,
      minWidthPercent = 96, // quanto si restringe il wrapper
      maxRadius = 20,
    } = options;

    const top = wrapper.getBoundingClientRect().top + window.scrollY;
    const start = top + offset;
    const end = start + range;

    const onScroll = () => {
      const y = window.scrollY;

      if (y <= start) {
        gsap.to(wrapper, {
          width: '100%',
          borderRadius: '0px',
          duration: 0.2,
          ease: 'linear',
        });
        return;
      }

      if (y >= end) {
        gsap.to(wrapper, {
          width: `${minWidthPercent}vw`,
          borderTopLeftRadius: `${maxRadius}px`,
          borderTopRightRadius: `${maxRadius}px`,
          duration: 0.2,
          ease: 'linear',
        });
        return;
      }

      const progress = (y - start) / (end - start);

      const width = 100 - progress * (100 - minWidthPercent);
      const radius = progress * maxRadius;

      gsap.to(wrapper, {
        width: `${width}%`,
        borderTopLeftRadius: `${radius}px`,
        borderTopRightRadius: `${radius}px`,
        duration: 0.2,
        ease: 'linear',
      });
    };

    window.addEventListener('scroll', onScroll);
    onScroll();

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }
  return false;
}
